export default class Utils {
  static getUrlParams = () => {
    return new URLSearchParams(window.location.href.replace(/^.*\?/gm, "?"));
  };
  static maskCpf = (value: string) => {
    if (!value) return "";
    return value
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  };
  static maskPhone = (value: string) => {
    if (!value) return "";
    const clean = value.replace(/\D/g, "");
    if (clean.length === 11) {
      return clean.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
    if (clean.length === 10) {
      return clean.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }
    return value;
  };
  static formatDate = (field: string | undefined | null) => {
    if (field && field !== "0001-01-01T00:00:00" && field !== "") {
      const parsedDate = new Date(field);
      if (!isNaN(parsedDate.getTime())) {
        return new Intl.DateTimeFormat("pt-BR", {
          dateStyle: "short",
        }).format(parsedDate);
      }
    }
    return "";
  };
}
